import { withInstall } from '../../../utils/with-install'
import LaserLayer from './LaserLayer.vue'

export const ElAmapLocaLaser = withInstall(LaserLayer)
export default ElAmapLocaLaser
